<template>
    <div style="direction:rtl">
        <CCard>
            <CCardHeader>
                <h3 class="card-title">تخلفات</h3>
            </CCardHeader>
            <CCardBody>
                <div style="display:flex;height:65vh;opverflow-y:scroll;gap:20px">
                    <div style="width:100%;height:65vh;">
                         <CDataTable
                            :hover="true"
                            :border="true"
                            
                            :striped="true"
                            :small="true"
                            :items="$store.state.Violation_GetAdvance.RequestResponse"
                            :fields="fields"
                            :fixed="true"
                            :loading="false"
                            :items-per-page="10"
                            pagination
                            :columnFilter='{}'
                            :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"
                        >
                            <template #Rows="{index}">
                                <td >
                                    {{index+1}}
                                </td>
                            </template>
                            <template #Edit="{item}">
                                <td >
                                    <CButton @click="Edit(item)" color="primary">ویرایش</CButton>
                                </td>
                            </template>
                        </CDataTable>
                    </div>
                    <div style="width:100%;height:65vh;max-width:250px;position: relative;">
                        <div style="width:100%;;position:absolute;top:0;display:flex;flex-direction:column">
                            <CSelect label="نوع فیلتر" style="width:100%;"    :options="FilterOption"  :value.sync="FilterSelect"   > </CSelect>
                            <CSelect v-if="FilterSelect!==3" label="خط" style="width:100%;" @change="ChangeFleet"    :options="GetOtions($store.state.Fleets.RequestResponse)"   :value.sync="FleetSelect"   > </CSelect>
                        
                            <CSelect v-if="FilterSelect===2" label="خودرو" style="width:100%;"    :options="GetOtionsDevice($store.state.Devices.RequestResponse)"  :value.sync="DeviceSelect"   > </CSelect>
                            
                        </div>
                        <div style="position:absolute;bottom:0;display:flex;flex-direction:column">
                            <label for="stTime" >از:</label> 
                            <date-picker style="width:250px;" v-model="FromDate"  id="stTime"  aria-label="از تاریخ" auto-submit  type="datetime"></date-picker>
                            <label for="stTime" >تا:</label> 
                            <date-picker style="width:250px;" v-model="ToDate"  id="stTime"  aria-label="از تاریخ"  auto-submit  type="datetime"></date-picker>
                                
                                <CButton color="primary" style="float: left;width:100px;height:35px;direction: ltr;margin-left:2%;margin-top: 15px" @click="Violation_GetAdvance()">
                                    <CIcon name="cil-search"/>&nbsp;به روز رسانی
                                </CButton>
                        </div>
                    </div>
                </div>
            </CCardBody>
            <CCardFooter style="display:flex;direction:ltr;gap:10px">
                    <MPrint 
                        v-if="$store.state.Violation_GetAdvance.RequestResponse.length>0"
                        :data="$store.state.Violation_GetAdvance.RequestResponse"
                        label="PDF" title="تخلفات" :From="FromDate" :TO="ToDate" :fields="fields">
                    </MPrint>             
            </CCardFooter>
        </CCard>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default {
        name: "Pages",
        data(){
            return {
                fields:[{"key":"Rows",label:"ردیف"},{"key":"VehicleName",label:"نام خودرو"},{"key":"FleetName",label:"نام خط"},{"key":"DriverName",label:"نام راننده"},{"key":"ViolationName",label:"عنوان تخلف"},{"key":"ViolationTS",label:"تاریخ"}],
                FilterOption:[
                    {value:3,label:'بدون فیلتر'},
                    {value:1,label:'بر اساس خط'},
                    {value:2,label:'بر اساس خودرو'},
                ],
                FromDate:'',
                ToDate:'',
                FilterSelect:3,
                FleetSelect:0,
                DeviceSelect:0,
            }
        },
        computed:{

        },
        watch:{

        },
        mounted(){
            var timeNow=Vue.moment().format('YYYY-MM-DD HH:mm:ss');
            var timefrom=Vue.moment().subtract(7,'days').format('YYYY-MM-DD HH:mm:ss');
            this.FromDate=Vue.moment(timefrom, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
            this.ToDate=Vue.moment(timeNow, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
            this.GetFleets();
        },
        methods:{
            GetFleets(){
                this.$store.commit('FleetByUser');
            },
            GetOtions(fleets){
                var options=[];
                var all={value:-1,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    var option={value:fleet.FleetID,label:fleet.FleetName};
                    options.push(option);
                }
                return options;
            },
            ChangeFleet(){
                
                this.$store.commit('Device_GetByFleetID',{
                    FleetID:this.FleetSelect
                });
            },
            Violation_GetAdvance(){
                var FromDate=Vue.moment(this.FromDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                var ToDate=Vue.moment(this.ToDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                this.$store.commit('Violation_GetAdvance',{
                    UserID:2188,
                    FleetID:this.FleetSelect,
                    DeviceID:this.DeviceSelect,
                    TS1:FromDate,
                    TS2:ToDate,
                    type:this.FilterSelect,
                });
                
            },
            GetOtionsDevice(devices){
                var options=[];
                var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<devices.length;i++){
                    var device=devices[i];
                    var option={value:device.DeviceID,label:device.CurrVehicleName};
                    options.push(option);
                }
                return options;
            },
        }
    }
</script>

<style scoped>

</style>